import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgSettings = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C13.1046 2 14 2.89543 14 4V4.25204C14.734 4.44096 15.4273 4.73146 16.0639 5.10764L16.2426 4.92893C17.0237 4.14788 18.29 4.14788 19.0711 4.92893C19.8521 5.70998 19.8521 6.97631 19.0711 7.75736L18.8924 7.93606C19.2685 8.57269 19.559 9.26596 19.748 10H20C21.1046 10 22 10.8954 22 12C22 13.1046 21.1046 14 20 14H19.748C19.559 14.734 19.2685 15.4273 18.8924 16.0639L19.0711 16.2426C19.8521 17.0237 19.8521 18.29 19.0711 19.0711C18.29 19.8521 17.0237 19.8521 16.2426 19.0711L16.0639 18.8924C15.4273 19.2685 14.734 19.559 14 19.748V20C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20V19.748C9.26596 19.559 8.57269 19.2685 7.93606 18.8924L7.75736 19.0711C6.97631 19.8521 5.70998 19.8521 4.92893 19.0711C4.14788 18.29 4.14788 17.0237 4.92893 16.2426L5.10764 16.0639C4.73146 15.4273 4.44096 14.734 4.25204 14H4C2.89543 14 2 13.1046 2 12C2 10.8954 2.89543 10 4 10H4.25204C4.44096 9.26596 4.73146 8.57269 5.10764 7.93606L4.92893 7.75736C4.14788 6.97631 4.14788 5.70998 4.92893 4.92893C5.70998 4.14788 6.97631 4.14788 7.75736 4.92893L7.93606 5.10764C8.57269 4.73146 9.26596 4.44096 10 4.25204V4C10 2.89543 10.8954 2 12 2ZM12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25Z", fill: props.fill }));
});
export default SvgSettings;
